import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { computed, ref, useAttrs } from 'vue';
import { Input } from 'Components/primitives/input';
import { Label } from 'Components/primitives/label';
import { cn } from 'Components/primitives/utils';
import { useValidation } from 'Components/inputs/useValidation';
export default /*@__PURE__*/ _defineComponent({
    ...{ inheritAttrs: false },
    __name: 'EnTextField',
    props: /*@__PURE__*/ _mergeModels({
        placeholder: { type: String, required: false },
        label: { type: String, required: false },
        disabled: { type: Boolean, required: false, default: false },
        readonly: { type: Boolean, required: false, default: false },
        rules: { type: Array, required: false },
        name: { type: String, required: false },
        labelOnLeft: { type: Boolean, required: false, default: false },
        hint: { type: String, required: false },
        persistentHint: { type: Boolean, required: false, default: false },
        staticId: { type: [String, Number, null], required: false, default: null },
        required: { type: Boolean, required: false, default: false }
    }, {
        "modelValue": {},
        "modelModifiers": {},
    }),
    emits: /*@__PURE__*/ _mergeModels(['update:modelValue'], ["update:modelValue"]),
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const attrs = useAttrs();
        const modelValue = _useModel(__props, 'modelValue');
        const emit = __emit;
        const isFocused = ref(false);
        const isDirty = ref(false);
        const { errorMessage, onBlur: onValidationBlur, } = useValidation(isDirty, props, modelValue);
        const labelComputed = computed(() => {
            return props.required ? `${props.label} *` : props.label;
        });
        const showHint = computed(() => !!props.hint && (props.persistentHint || isFocused.value));
        function onInput(event) {
            const value = event.target.value;
            modelValue.value = value;
            emit('update:modelValue', value);
            isDirty.value = true;
        }
        function onFocus() { isFocused.value = true; }
        function onBlur() {
            isFocused.value = false;
            isDirty.value = true;
            onValidationBlur();
        }
        const __returned__ = { props, attrs, modelValue, emit, isFocused, isDirty, errorMessage, onValidationBlur, labelComputed, showHint, onInput, onFocus, onBlur, get Input() { return Input; }, get Label() { return Label; }, get cn() { return cn; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
